var $8542973e6b42ac7a$exports = {};
$8542973e6b42ac7a$exports = {
    "alert": `Uyar\u{131}`,
    "dismiss": `Kapat`
};


export {$8542973e6b42ac7a$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
